import "./TextInputComp.css";
import { defineComponent as p, getCurrentInstance as r, resolveComponent as i, openBlock as s, createBlock as a, mergeProps as d } from "vue";
import { u } from "./uniqueId.f48d78c2.js";
import { d as l, v as m } from "./main.88c600c1.js";
import { _ as c } from "./_plugin-vue_export-helper.dad06003.js";
const f = ["underlined", "outlined", "filled", "solo", "plain"], _ = p({
  name: "text-input-comp",
  components: { VTextField: l },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => u("textInputComp")
    },
    "validate-on": {
      type: String,
      default: "blur"
    },
    color: {
      type: String,
      default: "primary"
    },
    variant: {
      type: String,
      default: "underlined",
      validator: (e) => f.includes(e)
    }
  },
  methods: {
    getInnerRef() {
      return this.$refs[this.id];
    }
  },
  setup() {
    const e = r();
    e && !e.appContext.mixins.some((n) => {
      var t;
      return (t = n.computed) == null ? void 0 : t.$vuetify;
    }) && e.appContext.app.use(m);
  }
});
function v(e, n, t, x, y, g) {
  const o = i("v-text-field");
  return s(), a(o, d({ class: "v-theme--customTheme" }, e.$props, { ref: e.id }), null, 16);
}
const T = /* @__PURE__ */ c(_, [["render", v], ["__scopeId", "data-v-b145a388"]]);
export {
  T as TextInputComp
};
//# sourceMappingURL=TextInputComp.js.map
